import { useState } from 'react';
import cn from 'classnames';
import { CalendarBlankFilled, UserFilled } from '@tag/tag-icons';
import dayjs from 'dayjs';

import Skeleton from '@/components/common/Skeleton/Skeleton';

import ButtonLink from '@/components/common/ButtonLink/ButtonLink';
import ViewFullNoteModal from '../ViewFullNoteModal/ViewFullNoteModal';
import { DEFAULT_DATE_PATTERN } from '@/config/common.config';
import styles from './note-item.module.scss';
import { User } from '@/hooks/identity/responseModels/user';

const charsLimit = 200;

interface INoteItemProps {
  className?: string;
  contractNote: ContractNote;
  user: User,
  isLoading: boolean
}

export default function NoteItem({
  className,
  contractNote,
  user,
  isLoading
}: INoteItemProps) {
  const [isVisibleFullNoteModal, setIsVisibleFullNoteModal] = useState(false);
  const isTextExceedsCharLimit = contractNote.text.length > charsLimit;
  const textToShowInNotePreview = isTextExceedsCharLimit
    ? `${contractNote.text.substring(0, charsLimit + 1)}...`
    : contractNote.text;

  const userName = `${user.FirstName ?? ''} ${user.LastName ?? ''}`.trim() || 'unavailable';

  return (
    <>
      <div className={cn(styles.note, className)}>
        <div className={styles.meta}>
          <span className={styles.username}>
            <UserFilled size="18" />
            <span>
              {isLoading ? <Skeleton width={150} /> : userName}
            </span>
          </span>
          <span className={styles.date}>
            <CalendarBlankFilled size="18" />
            <span>{dayjs(contractNote.created).format(DEFAULT_DATE_PATTERN)}</span>
          </span>
        </div>
        <div className={styles.text}>
          {textToShowInNotePreview}
          &nbsp;
          {isTextExceedsCharLimit && (
            <ButtonLink className={styles['expend-link']} onClick={() => setIsVisibleFullNoteModal(true)}>
              Expand Note
            </ButtonLink>
          )}
        </div>
      </div>

      {isVisibleFullNoteModal && (
        <ViewFullNoteModal
          text={contractNote.text}
          onClose={() => setIsVisibleFullNoteModal(false)}
        />
      )}
    </>
  );
}
